import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {baseUrl} from '@/config/env';


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('部门名称为1-30位中文'))
    } else {
        callback();
    }
}

export const menuTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    labelWidth: '120',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "菜单名称",
            prop: "name",
            placeholder: "请输入菜单名称",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },{
            label: "上级菜单",
            prop: "superiorId",
            placeholder: "请选择上级菜单",
            solt: true,
            formsolt: true
        },
        {
            label: "菜单类型",
            prop: "type",
            // solt: true,
            formsolt: true
            // type: "select",
            //dicData: DIC.MENU_TYPE,
            // rules: [{
            //     required: true,
            //     trigger: "blur",
            //     message: "请选择菜单类型"
            // }]
        },
        {
            label: "路径",
            prop: "uri",
            placeholder: "输入路径",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入输入路径"
            }]
        },
        {
            label: "图标",
            prop: "icon",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入图标"
            }]
        },
        {
            label: "权限值",
            prop: "permissionValue",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入权限值"
            }]
        },
        {
            label: "是否为公开菜单",
            prop: "isPublicMenu",
            type: "radio",
            hide: true,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.STATUS_STATE_MODEL
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            max: 255
        }


    ]
};